import { IPreloadedState } from 'shared/types/redux';

export const selectFilters = (state: IPreloadedState) => state.marketTrends.filters;
